import styles from "../css/SetupTable.module.css";
export default function MealSchedulingTable({ meals, setMeals, onMealAction }) {


  function updateOrderTypes(id, type) {
    console.log("updating order types : ", id, type)
    setMeals(meals.map(obj => {
      if (obj.meal_uuid === id) {
        console.log("previos order types : ", obj.order_types);
        if (obj.order_types.find(n => +n === +type))
          obj.order_types = obj.order_types.filter(n => +n !== +type)
        else
          obj.order_types.push(+type)

        console.log("updated order types : ", obj.order_types);

        return { ...obj, edit: true };
      }
      else
        return obj;
    }))
  }

  return (
    <table className={styles.table}>

      <thead>
        <tr>
          <th>Meal Title</th>
          <th>Sort Order</th>
          <th>Status</th>
          <th>Order Type</th>
          <th>Action</th>
        </tr>
      </thead>

      <tbody style={{ width: "100%" }}>
        {meals?.map((value, index) => {
          return <tr className={styles.tableRow}>
            <td className={styles.titleColumn}>
              <input
                className={styles.mealTitleInput}
                name="meal_title"
                value={value.meal_title}
                onChange={e => setMeals(meals.map(a => a.meal_uuid === value.meal_uuid ? ({ ...a, meal_title: e.target.value, edit: true }) : a))}
                type="text"
              />
            </td>
            <td>
              {console.log("mealData", value)}
              <input
                type="number"
                name="sort-order"
                id={`sort-order-${value.meal_uuid}`}
                className={styles.sort_order}
                min={0}
                max={meals.length}
                value={+value?.sort_order || 0}
                onChange={e => {
                  setMeals(meals.map(a =>
                    a.meal_uuid === value.meal_uuid
                      ? ({ ...a, sort_order: e.target.value, edit: true }) : a))
                }}
              />
            </td>
            <td className={styles.statusColumn}>
              <div className="input-div">
                <input
                  type="checkbox"
                  name="meal_status"
                  checked={+value.status === 1}
                />
                <div
                  className="checkmark"
                  onClick={e =>
                    setMeals(meals.map(a =>
                      a.meal_uuid === value.meal_uuid
                        ? ({ ...a, status: +a?.status === 1 ? "0" : "1", edit: true }) : a))
                  } />
              </div>
            </td>
            <td className={styles.selectColumn}>
              <div
                key={Math.random()}
                className="input-div"
                style={{ margin: "5px 0" }}
              >
                <label>
                  <input
                    type="checkbox"
                    name="Take Away"
                    label-value="Take Away"
                    defaultChecked={value?.order_types?.find(t => +t === 1)}
                    onChange={() => updateOrderTypes(value?.meal_uuid, "1")}
                  />
                  <div className="checkmark"></div>
                  Take Away
                </label>
              </div>
              <div
                key={Math.random()}
                className="input-div"
                style={{ margin: "5px 0" }}
              >
                <label>
                  <input
                    type="checkbox"
                    name="Delivery"
                    defaultChecked={value?.order_types?.find(t => +t === 2)}
                    onChange={() => updateOrderTypes(value?.meal_uuid, "2")}
                  />
                  <div className="checkmark"></div>
                  Delivery
                </label>
              </div>
            </td>
            <td className={styles.actionColumn}>
              <button
                type="button"
                onClick={() => onMealAction(value?.meal_uuid)}
                className={styles.actionButton}
              >
                Setting
              </button>
            </td>
          </tr>
        })}
      </tbody>
    </table>
  );
}
